import axios from "axios";
import { api_uri, enum_api_uri } from "./enum";
import { useAuthStore } from "user/store/useAuthStore";

const axiosInstance = axios.create({
    baseURL: api_uri,
});

// 토큰 갱신 상태 관리
let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

// 토큰 갱신 완료 시 대기 중인 요청 처리
const onRefreshed = (token: string) => {
    refreshSubscribers.forEach(callback => callback(token));
    refreshSubscribers = [];
};

// 요청 인터셉터
axiosInstance.interceptors.request.use(
    config => {
        const user = useAuthStore.getState();
        const accessToken = useAuthStore.getState().accessToken; // 스토어에서 토큰 가져오기
        if (user.m_category) {
            if (accessToken) {
                config.headers["Authorization"] = `Bearer ${accessToken}`; // 헤더에 토큰 추가
            } else {
                // token 없을경우 로그아웃 처리후 로그인페이지로 이동
                useAuthStore.getState().clearAuth();
                window.location.href = "/";
            }
        }
        return config; // 수정된 config 반환
    },
    error => {
        return Promise.reject(error);
    },
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
    response => {
        return response; // 성공적으로 응답이 오면 그대로 반환
    },
    async error => {
        const originalRequest = error.config;
        const user = useAuthStore.getState();

        if (user.m_category) {
            if (error.response && error.response.status === 401) {
                // 토큰 에러시
                if (!isRefreshing) {
                    isRefreshing = true;
                    const refreshToken = useAuthStore.getState().refreshToken; // 리프레시 토큰 가져오기

                    try {
                        const { data } = await axios.post(enum_api_uri.refresh, { refresh_token: refreshToken });

                        // 새로운 accessToken, refreshToken을 스토어에 저장
                        useAuthStore.getState().setAuth({ accessToken: data.accessToken, refreshToken: data.refreshToken });

                        // 모든 대기 중인 요청에 갱신된 토큰 제공
                        onRefreshed(data.accessToken);
                        isRefreshing = false;

                        // 갱신된 토큰을 헤더에 추가
                        originalRequest.headers["Authorization"] = `Bearer ${data.accessToken}`;

                        // 실패했던 요청 재시도
                        return axiosInstance(originalRequest);
                    } catch (refreshError) {
                        // 리프레시 토큰 갱신 실패 시 로그아웃 처리후 로그인페이지로 이동
                        useAuthStore.getState().clearAuth();
                        window.location.href = "/";

                        return Promise.reject(refreshError);
                    }
                } else {
                    // 토큰 갱신 중인 경우, 새로운 요청을 대기
                    return new Promise((resolve, reject) => {
                        refreshSubscribers.push((token: string) => {
                            originalRequest.headers["Authorization"] = `Bearer ${token}`;
                            resolve(axiosInstance(originalRequest));
                        });
                    });
                }
            }
        }

        // 그 외의 에러는 그대로 반환
        return Promise.reject(error);
    },
);

export default axiosInstance;
